export default "__VITE_ASSET__obbLxnE3__"